import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';
import { SwPush } from '@angular/service-worker';

@Injectable({
  providedIn: 'root'
})
export class AlertasPushService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };
  private vapidPublicKey: string = 'BFhtvZFInge_pKL321LWnggO9W6LhvRgFCs4VJnhcRMdcj39nA35GlKvcLotIZfl19D5gnPeUEoe4OKsA5NP69Y';

  constructor(private tokenService: TokenService, private http: HttpClient, private swPush: SwPush) { }

  obterConfigAlertasPush(): Observable<any> {
    return this.http.get(`${this.apiUrl}api/configuracao-alerta-chat`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    })
      .pipe(
        catchError(this.handleError)
      );
  }

  atualizarConfigAlertasPush(payload): Observable<any> {
    return this.http.put(`${this.apiUrl}api/configuracao-alerta-chat`, payload, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    })
      .pipe(
        catchError(this.handleError)
      );
  }

  atualizarTokenNotificacaoPush(payload): Observable<any> {
    return this.http.put(`${this.apiUrl}api/central-notificacao/bandeja/atualiza-token`, payload, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    })
      .pipe(
        catchError(this.handleError)
      );
  }

  testarNotificacao(payload): Observable<any> {
    return this.http.post(`${this.apiUrl}api/central-notificacao/bandeja/testar-envio`, payload, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    })
      .pipe(
        catchError(this.handleError)
      );
  }

  validaServiceWorker(): void {
    setTimeout(() => {
      if (Notification.permission !== 'granted') {
        return;
      }

      this.swPush.requestSubscription({
        // usa a chave VAPID PUBLICA EXATAMENTE como saiu do web-push
        serverPublicKey: this.vapidPublicKey.trim()
      })
        .then(sub => {
          const subscriptionJSON = sub.toJSON(); // 👈 ESSENCIAL

          this.atualizarTokenNotificacaoPush({
            web_push_notification_token: subscriptionJSON
          }).subscribe({
            next: () => console.log('Token push atualizado com sucesso.'),
            error: (error) => console.error('Erro ao atualizar token push:', error)
          });
        })
        .catch(err => {
          console.error('Erro ao criar subscription:', err);
        });

    }, 1000);
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
